import { GetNovelRankingsRequest, type NovelRankingType } from '@app/_proto/Protos/novel_rankings';
import { NovelRankingsClient } from '@app/_proto/Protos/novel_rankings.client';
import type { NovelItem } from '@app/_proto/Protos/novels';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';
import { sortBy } from 'lodash-es';
import { useMemo } from 'react';

type UseNovelRankingsParam = {
    type: NovelRankingType;
    enabled?: boolean;
};

type UseNovelRankingsReturn = {
    data: NovelItem[] | undefined;
    isSuccess: boolean;
};

export default function useNovelRankings({ type, enabled }: UseNovelRankingsParam): UseNovelRankingsReturn {
    const rankingsRequest = useGrpcRequest(GetNovelRankingsRequest, {
        type: type,
        count: 12,
    });

    const { data, isSuccess } = useGrpcApiWithQuery(
        NovelRankingsClient,
        c => c.getNovelRankings,
        rankingsRequest,
        ['novel-rankings', type],
        {
            enabled,
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours cache
            staleTime: 1000 * 60 * 60 * 24, //Data stales in 24 hours
        }
    );

    const novels = useMemo(() => {
        const sorted = data?.items ? sortBy(data?.items, 'rank') : undefined;
        return sorted?.map(r => r.item!);
    }, [data?.items]);

    return {
        data: novels,
        isSuccess,
    };
}
